import Vue from 'vue'
import UIKit from '../UIKit'
Vue.use(UIKit)